export { Divider, type DividerProps } from './Divider';
